import { NumericFormat } from "react-number-format";
import { FallBackImage } from "../default/fallback-image";

export default function HomeLastOffers({ ads }) {
    return (
        <>
            <section className="latest-collection pb-120">
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-lg-12 d-flex justify-content-center">
                            <div className="at-section-title text-center text-lg-start font-smaller">
                                <span className=" position-relative lead text-primary first-shadow ml-200">Confira nossas</span>
                                <br/>
                                <span className=" position-relative lead text-primary last-shadow">Últimas ofertas</span>
                            </div>
                        </div>
                    </div>
                    <div className="filter-items-wrapper mt-5">
                        <div className="row g-4 justify-content-center filter-grid">
                            {
                                ads.items.map((item, index) => <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-6 col-xxs-12" key={index}>

                                    <a href={`anuncio/${item.category}/${`${item.brand.split(' ').join('-').toLowerCase()}-${item.model.split(' ').join('-').toLowerCase()}`}/${item.yearModel}/${item.id}`}>
                                    <div className="pointer filter-card-item position-relative overflow-hidden rounded bg-white">
                                    <div className="price-btn text-center position-relative">
                                        <div className="mt-2 d-block h5 px-2">
                                            {`${item.brand} ${item.model}`}
                                        </div>
                                    </div> 
  
                                        <div
                                            className="feature-thumb position-relative overflow-hidden border-bottom"
                                            style={{
                                                position: 'relative',
                                                width: '100%',
                                                maxWidth: '430px',
                                                aspectRatio: '70/45'
                                            }}>
                                                <FallBackImage
                                                    className='img-card-fluid'
                                                    priority={true}
                                                    alt={`${item.brand} ${item.model}`}
                                                    src={item.mainPhoto ? item.mainPhoto : "/img/no-image.jpeg"} />
                                        </div>
                                        
                                        <div className="filter-card-content">  
                                        <div className="price-btn text-center position-relative">
                                                {
                                                    item.promotionalPrice
                                                        ? <h5 className="price">
                                                            {
                                                                item.price ?
                                                                    <NumericFormat
                                                                        className="small-btn-meta"
                                                                        style={{ color: 'var(--color-primary)', fontSize: '14px', textDecoration: 'line-through' }}
                                                                        value={item.price ?? 0}
                                                                        displayType={'text'}
                                                                        thousandSeparator="."
                                                                        decimalSeparator=","
                                                                        decimalScale={2}
                                                                        fixedDecimalScale={true}
                                                                        prefix='De R$ ' />
                                                                    : 'consulte-nos'
                                                            }
                                                        </h5>
                                                        : null
                                                }
                                                <div style={{minHeight: item.promotionalPrice ? null : "68px" }} className="d-flex justify-content-center align-items-center">
                                                    <h5 className="price">
                                                        {
                                                            item.price ?
                                                                <NumericFormat
                                                                    className={`${item.promotionalPrice ? 'price-bigger' : null}`}
                                                                    style={{ fontSize: item.promotionalPrice ? '16px' : '18px'}}
                                                                    value={item.promotionalPrice ? item.promotionalPrice : item.price}
                                                                    displayType={'text'}
                                                                    thousandSeparator="."
                                                                    decimalSeparator=","
                                                                    decimalScale={2}
                                                                    fixedDecimalScale={true}
                                                                    prefix={`${item.promotionalPrice ? 'Por R$ ' : 'R$ '}`} />
                                                                : 'consulte-nos'
                                                        }
                                                    </h5>
                                                </div>

                                            </div> 
                                            <hr className="spacer mb-3" />                                          
                                            {/*<span
                                                className="meta-content"
                                                style={{
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    display: 'inline-block',
                                                    width: '100%'
                                                }}>{item.version}</span>
                                            <hr className="spacer mt-3 mb-3" />*/}
                                            
                                            <div className="grid-carinfo">
                                            <div className="cut-text">
                                                <i className="flaticon-steering-wheel"></i>
                                                {item.transmission}
                                            </div>
                                            <div className="cut-text">
                                                <i className="flaticon-petrol"></i>
                                                {item.fuel}
                                            </div>
                                            <div className="cut-text">
                                                <i className="flaticon-calendar"></i>
                                                {item.yearModel}
                                            </div>
                                            <div className="cut-text">
                                                <i className="flaticon-star"></i>
                                                {item.color}
                                            </div>
                                            </div>
                                           <div className="btn btn-secondary btn-md d-block font-size-12" style={{marginBottom: "10px"}}> <i></i><span>Saiba Mais</span> </div>
                                            </div>
                                    </div>
                                    </a>
                                </div>)
                            }
                        </div>
                    </div>
                    <div className="text-center mt-5">
                        <a href="/estoque" className="at-explore-btn color-secondary">
                            <span className="me-2">
                                <i className="fa fa-square-plus"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </section>
        </>
    )
}